import { KeyboardEvent, useContext, useEffect, useState } from "react";
import ValoresInputContext from "./context/FiltrosInputContext";
import Select from 'react-select'

export default function FiltrosListado(props: FiltrosListadoProps) {
    const [titulo, setTitulo] = useState("");
    const [autor, setAutor] = useState("");
    const [ISBN, setISBN] = useState("");  
    const [coleccion, setColeccion] = useState("");

    const inputTexto = useContext<any>(ValoresInputContext)
    useEffect(()=>{
        setTitulo(inputTexto.titulo)
        setAutor(inputTexto.autor)
        setISBN(inputTexto.ISBN)
        setColeccion(inputTexto.coleccion)
    },[])
    const Filtros = (e: KeyboardEvent<HTMLInputElement>, tipo:number) =>{  
        switch (tipo) {
            case 0:
               setTitulo(e.currentTarget.value)
            break;
            case 1:
                setAutor(e.currentTarget.value)
            break;
            case 2:
                setISBN(e.currentTarget.value)
            break; 
            case 3:
                setColeccion(e.currentTarget.value)
            break; 
        }          
    }  
    
    const asignaValor= (e:any, tipo:number) => {
        switch (tipo) {
            case 0:
               setTitulo(e.value)
            break;
            case 1:
                setAutor(e.value)
            break;
        }    
      }    
    const resetFiltros = async() =>{
        localStorage.setItem('fil_titulo','') 
        localStorage.setItem('fil_palabraClave','') 
        localStorage.setItem('fil_autor','') 
        setTitulo('') 
        setAutor('')
        setISBN('') 
        setColeccion('')
        generaFiltros();             
    return;
}
    const generaFiltros = () => props.getFiltros({titulo, autor, ISBN, coleccion, palabraClave:''})
    const titulos = (props.predictivos.Table)
    const autores = (props.predictivos.Table1)
    return(
        <div className="row mt-2">
            <div className="col-1"></div>
             <div className="col-3">Título<Select options={titulos} onChange={(e)=>asignaValor(e, 0)} className="mt-2" placeholder="Título" /></div>
             <div className="col-3">Autor<Select options={autores} onChange={(e)=>asignaValor(e, 1)} className="mt-2" placeholder="Autor" /></div>
            {/* <div className="col-3">Titulo<input onKeyUp={(e)=>Filtros(e,0)} defaultValue={inputTexto.titulo} onChange={e => titulo} type="text" className="form-control mt-2" maxLength={50}/></div> */}
            {/* <div className="col-3">Autor<input  onKeyUp={(e)=>Filtros(e,1)} defaultValue={inputTexto.autor} onChange={e => autor} type="text" className="form-control mt-2" maxLength={50}/></div> */}
            <div className="col-2">ISBN<input onKeyUp={(e)=>Filtros(e,2)} defaultValue={inputTexto.ISBN} onChange={e => ISBN} type="text" className="form-control mt-2" maxLength={50}/></div>
            <div className="col-3 d-flex align-items-end">
                <div className="col-8">Colección<input onKeyUp={(e)=>Filtros(e,3)} defaultValue={inputTexto.coleccion} onChange={e => coleccion} type="text" className="form-control mt-1" maxLength={50}/></div>
                <div className="col-2"><button type="button" className="mt-1 btn btn-primary separacionBoton" onClick={generaFiltros}>Filtrar <i className="fa fa-filter" aria-hidden="true"></i> </button></div>
                <div className="col-2"><button type="button" className="mt-1 btn btn-warning separacionBoton" onClick={()=>resetFiltros()}><i className="fa fa-eraser" aria-hidden="true"></i></button></div>
            
            </div>
        </div>
    )
    }
    interface FiltrosListadoProps{
        getFiltros(filtro:any):void,  
        predictivos:any
    }